export default "__VITE_ASSET__Bzm9d36y__"